module.exports = __webpack_public_path__ + "img/bgaming.30511fc6.svg";